export default __webpack_public_path__ + "static/media/bannersWEBINAR_04junio.44c07e33.jpg";